import { registerVPortal, loadTwbsPagination } from "../main/utils/vportal.js";

function loadLazyImages(list) {
  list.querySelectorAll("img.MJ__lazyload[data-src]:not(.MJ__loaded)").forEach(function (img) {
    img.src = img.dataset.src;
    img.classList.add("MJ__loaded");
  });
}

// lib chỉ quét MJ__lazyload 1 lần lúc init; vPortal thay list bằng ajax nên ảnh mới phải tự nạp
function watchAjaxList(list) {
  new MutationObserver(function () {
    loadLazyImages(list);
  }).observe(list, { childList: true });
}

function initListNews(retry) {
  retry = retry || 0;

  if (!document.querySelector(".ln-list")) return;
  var $ = window.jQuery || window.$;
  if (!$) {

    if (retry < 20) setTimeout(function () { initListNews(retry + 1); }, 100);
    return;
  }

  registerVPortal($);
  document.querySelectorAll(".news-list").forEach(watchAjaxList);

  loadTwbsPagination(function () {
    $(".news").each(function () {
      var postsTag = "#" + $(this).attr("id");
      $(postsTag).vPortal({
        container: postsTag,
        el: {
          tabContainer: ".news-tabs > a",
          resultContainer: ".news-list",
          paginationContainer: ".pagination",
        },

        paginationOptions: {
          first: "«",
          prev: "‹ Trang trước",
          next: "Trang kế ›",
          last: "»",
          visiblePages: 5,
        },
      });

      var $active = $(postsTag + " .news-tabs > a.active");
      if ($active.length && $active.data("block-name")) $active.trigger("click");
    });
  });
}

window.addEventListener("load", function () {
  initListNews();
});
